import { createSlice } from '@reduxjs/toolkit'
import * as dom from "../../models/domain";
import { Chat } from "../../../store/models/domain/chat"
import { getContactsThunk, saveContactWaiverThunk } from '../../actions/domain/chat';

const initialState: dom.ChatState = {
    record: {
        contacts: [],
    },
    loading: 'idle',
    isInitialized: false,
    error: null
}

export type ChatState = {
    chat: Chat
}

const chatSlice = createSlice({
    name: 'chat',
    initialState,
    reducers: {
        initChatState(state) {
            state.isInitialized = true;
        }
    },
    extraReducers: builder => {

        // get chat contacts
        builder.addCase(getContactsThunk.fulfilled, (state, action) => {
            return {
                ...state,
                record: {
                    contacts: action.payload
                },
                loading: 'succeeded',
                error: null,
            }
        })
        builder.addCase(getContactsThunk.rejected, (state, action) => {
            return { ...state, loading: 'failed', error: action.error }
        })
    }
})

export const { initChatState } = chatSlice.actions;

export default chatSlice.reducer